import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';

export interface IGetUserHashResp {
  user_hash: string;
}

@Injectable({
  providedIn: 'root',
})
export class IntercomGateway {
  private readonly _http = inject(HttpClient);

  getId(jwt: string): Observable<IGetUserHashResp> {
    return this._http.get<IGetUserHashResp>(
      'https://intercom.emarketing.com/id',
      {headers: this._buildAuthHeader(jwt)},
    );
  }

  private _buildAuthHeader(jwt: string): {Authorization: string} {
    return {Authorization: jwt};
  }
}
